import React from 'react'
import {HStack, Text, useStyleConfig, Box, VStack, Button} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {FeedbackWarningIcon, CloseIcon, FeedbackSuccessIcon} from '../icons'

function Feedback({
    status = 'success',
    message,
    description,
    onClose,
    action,
    variant = 'success',
    enableIcon = true,
    promoLabel = null,
    enableCloseIcon = true,
    enableUndoButton = false,
    undoButtonAction = () => {},
    undoButtonLabel = 'Undo',
    ...rest
}) {
    const styles = useStyleConfig('Feedback', {status, variant})

    let icon = null
    if (status !== null || status !== undefined) {
        icon =
            status === 'success' ? (
                <FeedbackSuccessIcon {...styles?.statusIcon} data-testid="status-icon" />
            ) : (
                <FeedbackWarningIcon {...styles?.statusIcon} data-testid="status-icon" />
            )
    }
    return (
        <Box {...styles.container} {...rest}>
            {variant === 'freeItemPromo' && promoLabel ? <HStack>{promoLabel}</HStack> : null}

            {enableIcon ? icon : <></>}
            <VStack {...styles.textContainer}>
                <Text {...styles.messageText}>{message}</Text>
                {description && <Text {...styles.descriptionText}>{description}</Text>}
            </VStack>

            {typeof action === 'string' ? {action} : action}

            {enableCloseIcon && (
                <CloseIcon
                    {...styles?.closeIcon}
                    onClick={onClose}
                    data-testid="feedback-close-icon"
                />
            )}

            {enableUndoButton && (
                <Button
                    variant="primary-not-rounded"
                    size="small"
                    onClick={() => {
                        undoButtonAction()
                        onClose()
                    }}
                    {...styles?.undoButton}
                >
                    {undoButtonLabel}
                </Button>
            )}
        </Box>
    )
}

Feedback.propTypes = {
    variant: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    description: PropTypes.string,
    onClose: PropTypes.func,
    action: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    status: PropTypes.string,
    enableIcon: PropTypes.bool,
    enableCloseIcon: PropTypes.bool,
    enableUndoButton: PropTypes.bool,
    undoButtonAction: PropTypes.func,
    undoButtonLabel: PropTypes.string,
    promoLabel: PropTypes.object,
}

export default Feedback
